export default "__VITE_ASSET__Ko9Ic1of__"